const styles = {
  viewer: {
    width: "100vw",
    height: "100%",
    background: "#040404",
    position: "fixed",
    flexDirection: "column",
    top: 0,
    zIndex: 1000002,
    display: "flex",
  },

  instagram: {
    display: "inline-block",
    color: "#FFFFFF",
    fontSize: "14px",
    fontWeight: 300,
    fontFamily: ({ theme }) => theme.fontFamily,
    position: "relative",
    left: "15px",
  },
  instagramTitle: {
    position: "relative",
    bottom: "7px",
    left: "10px",
  },
  instagramDescription: {
    marginTop: "10px",
  },

  description: {
    position: "fixed",
    width: "33.3%",
    height: "100vh",
    top: 0,
    right: 0,
    background: "rgba(0, 0, 0, 0.9)",
    zIndex: 1000005,
    "@media screen and (max-width : 767px) and (orientation: portrait)": {
      width: "100%",
    },
    wordBreak: "break-word",
  },

  closeIcon: {
    position: "absolute",
    right: "3%",
    top: "3%",
  },

  descriptionText: {
    position: "absolute",
    top: "84px",
    left: "32px",
    width: "293px",
    color: "white",
    fontFamily: "CircularStd",
    fontSize: "16px",
    fontWeight: "300",
    letterSpacing: "0",
    lineHeight: "24px",
  },

  topContainer: {
    boxSizing: "border-box",
    backgroundColor: "#040404",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "56px",
    paddingLeft: "15px",
    paddingRight: "15px",
    boxShadow: "0 2px 4px 0 rgba(0,0,0,0.1)",
    "@media screen and (orientation: landscape)": {
      marginTop: "12px",
    },
  },

  counter: {
    color: "white",
    fontFamily: "CircularStd",
    fontSize: "16px",
    fontWeight: "300",
    letterSpacing: "0",
    display: "inline-block",
  },

  navigate: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "fixed",
    top: "90vh",
    width: "calc(100% - 56px)",
    marginLeft: "28px",
    marginRight: "28px",
  },
  caret: {
    position: "relative",
    top: "6px",
    display: "inline-block",
  },

  rotate: {
    top: "-3px",
    transform: "rotate(180deg)",
  },

  imgContainer: {
    width: "100%",
    "@media screen and (orientation: portrait)": {
      maxHeight: "60%",
      marginTop: "30px",
    },
    "@media screen and (orientation: landscape)": {
      maxHeight: "50%",
      marginTop: "10px",
    },
  },
  info: {
    cursor: "pointer",
    position: "absolute",
    right: "3%",
    top: "7%",
    zIndex: 1000,
    "@media screen and (max-width : 1200px)": { display: "none" },
  },

  imgText: {
    position: "absolute",
    bottom: "5%",
    left: "24px",
    height: "46px",
    width: "540px",
    color: "#FFFFFF",
    fontFamily: '"CircularStd"',
    fontSize: "36px",
    fontWeight: "500",
    lineHeight: "46px",
    zIndex: "10",
    textShadow: "0 2px 4px 0 rgba(0,0,0,0.5), 0 6px 20px 0 rgba(0,0,0,0.4)",
    "@media screen and (max-width : 1200px)": {
      display: "none",
    },
  },
  imgTitle: {
    "@media screen and (orientation: portrait)": {
      marginTop: "30px",
    },
    "@media screen and (orientation: landscape)": {
      marginTop: "10px",
    },
    padding: "0 25px",
    color: "white",
    fontFamily: "CircularStd",
    fontSize: "20px",
    fontWeight: "500",
    letterSpacing: "0",
    lineHeight: "25px",
    textShadow: "0 2px 4px 0 rgba(0,0,0,0.5)",
  },
};
export default styles;
